import React from "react";

const CustomCheckbox = ({ checked, onChange, style, label }) => (
    <div style={style} className="custom-checkbox-relative">
        <div onClick={onChange} className={`custom-checkbox ${checked ? "custom-checkbox-active" : ''}`} />
        {label && <em onClick={onChange} className="custom-checkbox-label">{label}</em>}
    </div>
    );

export default CustomCheckbox